<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }

</script>

<style>
  @import './assets/css/global.css';

</style>



// WEBPACK FOOTER //
// src/App.vue